import React from 'react';
import styled from 'styled-components';
import useLocale from '../../hooks/useLocale';

const LEVEL_COLORS = {
  high:    { accent: 'strong',      bg: '#E8F5E9' },
  partial: { accent: 'weak',        bg: '#FFF8E1' },
  low:     { accent: 'challenging', bg: '#FFEBEE' },
};

const Banner = styled.div`
  background: ${p => LEVEL_COLORS[p.level].bg};
  border-left: 4px solid ${p => p.theme.colors.bands[LEVEL_COLORS[p.level].accent]};
  border-radius: ${p => p.theme.radius.md}px;
  padding: ${p => p.theme.spacing[3]}px ${p => p.theme.spacing[4]}px;
  margin: ${p => p.theme.spacing[4]}px 0;
  font-size: ${p => p.theme.typography.sizes.md};
  color: ${p => p.theme.colors.text.primary};
  font-weight: ${p => p.theme.typography.weights.medium};
`;

const AgreementBanner = ({ level, lang = 'en' }) => {
  const safeLevel = LEVEL_COLORS[level] ? level : 'partial';
  const t = useLocale(lang, 'comparison');
  const text = t.agreement?.[safeLevel] || `Agreement: ${safeLevel}`;

  return (
    <Banner level={safeLevel} role="status" aria-live="polite">
      {text}
    </Banner>
  );
};

export default AgreementBanner;
